module.exports = __webpack_public_path__ + "static/media/Steiger@ax.91237cb7.jpg";